import React, { useState } from 'react';
import { Layout, Tabs, Typography } from 'antd';
import { 
  ApiOutlined, 
  PlayCircleOutlined,
  ApartmentOutlined
} from '@ant-design/icons';
import {ReactComponent as Mapchise_logo} from '../Layer_images/Mapchise-logo.svg';
import WorkflowsTab from './WorkflowsTab';
import ConnectionsTab from './ConnectionsTab';
import ExecutionTab from './ExecutionTab';
import './Workflows.css';

const { Header, Content } = Layout;
const { Title } = Typography;
const { TabPane } = Tabs;

const Workflows = () => {
  const [activeTab, setActiveTab] = useState('workflows');

  const tabItems = [
    {
      key: 'workflows',
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <ApartmentOutlined style={{ marginRight: '8px' }} />
          Workflows
        </span>
      ),
      children: <WorkflowsTab />
    },
    {
      key: 'connections',
      label: (
        <span>
          <ApiOutlined />
          Connections
        </span>
      ),
      children: <ConnectionsTab />
    },
    {
      key: 'execution',
      label: (
        <span>
          <PlayCircleOutlined />
          Execution
        </span>
      ),
      children: <ExecutionTab />
    }
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ 
        background: '#fff', 
        padding: '0 24px', 
        borderBottom: '1px solid #f0f0f0',
        boxShadow: '0 1px 4px rgba(0,21,41,.08)'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          height: '100%'
        }}>
          <Title level={3} style={{ margin: 0, color: '#1890ff', display: 'flex', alignItems: 'center' }}>
            <Mapchise_logo width={54} style={{marginRight: '8px'}}/>
            Workflow Builder
          </Title>
        </div>
      </Header>

      <Content style={{ padding: '24px' }}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          size="large"
          items={tabItems}
          className="workflows-tabs"
        />
      </Content>
    </Layout>
  );
};

export default Workflows;